import {
  PRIMARY_NAVIGATION_STRIP_LABEL_FONT_SIZE,
  PRIMARY_NAVIGATION_STRIP_LABEL_LINE_HEIGHT,
} from "@-/dev.improve.haniverse.lib.nav-chrome.entities";
import { Platform, Text, type ColorValue } from "@-/com.npmjs.react-native";

export function PrimaryNavigationStripLabel({
  color,
  focused,
  label,
}: {
  color: ColorValue;
  focused: boolean;
  label: string;
}) {
  return (
    <Text
      className="mt-0 font-han-composite"
      style={{
        color,
        fontSize: PRIMARY_NAVIGATION_STRIP_LABEL_FONT_SIZE,
        fontWeight: focused
          ? Platform.OS === "android"
            ? "900"
            : "700"
          : Platform.OS === "android"
            ? "bold"
            : "500",
        lineHeight: PRIMARY_NAVIGATION_STRIP_LABEL_LINE_HEIGHT,
      }}
    >
      {label}
    </Text>
  );
}
